import InputInspector from "./InputInspector";



const validateInput = (inputName, inputStatus ,inputValue )=>{

    const reportInputLength = InputInspector.inspectInputLength(inputName, inputStatus, inputValue);
    const reportInputValue = InputInspector.inspectInputValue(inputName, inputValue);
    const validationReport = Object.assign({},reportInputLength,reportInputValue);    

    return validationReport;
}

const compareInputsAreEqual = function(inputObj){
    const comparisonReport = InputInspector.compareInputsAreEqual(inputObj); 

    return comparisonReport;
}

const processErrors = function (reportObj , htmlInputName){
    //console.log("processErrors-reportObj", reportObj);

    let errorsReport = "";
    for(let key in reportObj){
        if(reportObj.hasOwnProperty(key)){
            const inputLowercaseIsFound = key.toLowerCase().includes(htmlInputName);
            const inputIsFound = key.includes(htmlInputName)
            if(inputIsFound){
                //console.log("key:", key);
                //console.log("htmlInputName", htmlInputName);
                errorsReport += reportObj[key];
            }
        }
    }

    return errorsReport;
}

const ValidationService = Object.freeze({
    validateInput : validateInput,
    compareInputsAreEqual : compareInputsAreEqual,
    processErrors : processErrors  
});

export default ValidationService;
